import { css, styled } from 'styled-components';

import { cssBreakpoints, shadows } from '#/theme/theme';

export const DropdownListMenuHolder = styled.menu`
  position: absolute;
  z-index: 2000;
  box-shadow: ${shadows.highest};
  background-color: white;
  border-radius: 4px;
  right: 0;
  top: 100%;
  margin-bottom: 0;
  margin-top: 4px;
  padding: 0;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;

export const DropdownListMenuList = styled.div<{
  $width: number;
  $maxHeight?: number | string;
}>`
  width: ${(props) => props.$width}px;
  overflow-x: hidden;

  ${(props) =>
    props.$maxHeight &&
    css`
      max-height: ${typeof props.$maxHeight === 'number'
        ? `${props.$maxHeight}px`
        : props.$maxHeight};
      overflow-y: scroll;
    `}
`;
